import React from "react";
import { BUTTON_CONSTANTS } from "./InvitedScheduler";
import { Button, Icon, Popconfirm } from "antd";
import { Translate } from "react-translated";
import SwitchIcon from "../../../assets/switch-icon-2.png";
import F from "../../../Functions";

const ActionButtonsRenderer = (props) => {
  const { data, onButtonClick, invitedState } = props;

  const handleButtonClick = (buttonType) => {
    if (buttonType === BUTTON_CONSTANTS.resend.key) {
      onButtonClick(buttonType, data);
    } else if (buttonType === BUTTON_CONSTANTS.delete.key) {
      onButtonClick(buttonType, data);
    }
  };

  return (
    <div style={{ display: "flex", gap: "12px", marginTop: "7px" }}>
      <Button
        className="borderRadius-28"
        onClick={() => handleButtonClick(BUTTON_CONSTANTS.resend.key)}>
        <img src={SwitchIcon} alt="Switch Icon" />&nbsp;
        <Translate text={BUTTON_CONSTANTS.resend.label} />
      </Button>
      <Popconfirm
        placement="topRight"
        title={<Translate text={`Do you really want to delete this invite?`} />}
        // onConfirm={() => this.delete(user.id)}
        onConfirm={() => handleButtonClick(BUTTON_CONSTANTS.delete.key)}
        okText={<Translate text={`Yes`} />}
        cancelText={<Translate text={`No`} />}
        okButtonProps={{ className: 'borderRadius-28 bg-164897' }}
        cancelButtonProps={{ className: 'borderRadius-28' }}
        getPopupContainer={F.getPopupContainer}
      >
        <Button type="danger" ghost
          className="borderRadius-28"
        >
          <Icon type="delete" />{" "}
          <Translate text={BUTTON_CONSTANTS.delete.label} />
        </Button>
      </Popconfirm>
    </div>
  );
};

export default ActionButtonsRenderer;



// WEBPACK FOOTER //
// ./src/scenes/ManageUsers/Invited Schedulers/ActionButtonsRenderer.js